module.exports = __webpack_public_path__ + "static/media/plp-dont-know-mobile.d0224f73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/plp-dont-know-mobile.jpg
// module id = 452
// module chunks = 0